import map from 'lodash/map';
import pickBy from 'lodash/pickBy';

const getMatchingReasonsLabel = ({ matchingReasonConstants, matchingReasons, opportunityType }) => {
  const validMatchingReasons = Object.keys(
    pickBy(matchingReasons, (value, key) => value && matchingReasonConstants?.[key]),
  );

  const matchingReasonStringsArray = map(validMatchingReasons, key =>
    matchingReasonConstants?.[key]?.getLabel?.({ opportunityType }),
  );

  return matchingReasonStringsArray?.[0] || '';
};

export default getMatchingReasonsLabel;
